







import { Vue, Component } from "vue-property-decorator";
import Prism from "vue-prism-component";
import { namespace } from "vuex-class";

const Integration = namespace("integration");

@Component({
  components: {
    prism: Prism,
  },
})
export default class Web extends Vue {
  @Integration.Getter("getPublicKey") publicKey;
  @Integration.Getter("getSecretKey") secretKey;

  code = ``;

  created() {
    this.code = `
import { renderButton } from "@orbaone/core";

renderButton({
  apiKey: "${this.publicKey}",
  target: "#button",
  disableStyle: false,
  onSuccess: (data) => { console.log(data) },
  onCancelled: (data) => { console.log(data) },
  onError: (err) => { console.log(err) }
})`;
  }
}
